// Single place to edit business details. Leave a value empty ("") to hide it on the site.
export const SITE = {
  name: "TOYAM",
  tagline: "The Water Behind Exceptional Hospitality",
  secondary: "Crafted in Agra. Inspired by Hospitality.",
  contact: {
    email: "", // e.g. "partners@yourdomain.com"
    phones: ["+91 9557881136", "+91 8265839483"],
    whatsapp: "919557881136", // digits only, country code first; "" hides the WhatsApp button
    whatsappMessage: "Hello TOYAM, I'd like to know more about your alkaline water for our property.",
    address: "", // e.g. "Registered office, Agra, Uttar Pradesh"
    instagram: "", // full https URL
    linkedin: "", // full https URL
  },
  legal: {
    companyName: "[Registered company name]",
    registeredAddress: "[Registered business address]",
    grievanceEmail: "[Grievance / privacy contact email]",
    lastUpdated: "[Date]",
  },
};

// Set published: true and fill in values once the accredited lab report is received; the Alkaline section then shows the results panel.
export const LAB_REPORT = {
  published: false,
  labName: "",
  reportRef: "",
  reportDate: "",
  reportUrl: "", // optional link to the PDF report
  ph: "",
  tds: "",
  minerals: [], // e.g. { name: "Calcium", value: "00 mg/L" }
};

export const NAV = [
  { id: "home", label: "Home" },
  { id: "story", label: "Our Story" },
  { id: "bottle", label: "The Bottle" },
  { id: "hotels", label: "For Hotels" },
  { id: "process", label: "Our Process" },
  { id: "sustainability", label: "Sustainability" },
  { id: "contact", label: "Contact" },
];

export const ENQUIRY = {
  businessTypes: ["Luxury hotel", "Boutique hotel", "Restaurant / fine dining", "Resort", "Banquet / events", "Spa / wellness", "Hospital / healthcare", "Corporate / government office", "Lounge / club", "Hospitality group", "Distributor / channel partner", "Other"],
  enquiryTypes: ["Hotel supply partnership", "Sample request", "Hotel co-branding / private label", "Commercial enquiry", "General enquiry"],
  quantities: ["Under 500 bottles", "500–1,500 bottles", "1,500–5,000 bottles", "5,000+ bottles", "Not sure yet"],
  formats: ["750 ml glass bottle", "Co-branded glass bottle", "To be discussed"],
};

export const IMG = {
  hero: "/img/hero.webp",
  heroMobile: "/img/hero-mobile.webp",
  bottleMaster: "/img/bottle-master.webp",
  story: "/img/story.webp",
  bottle: "/img/bottle.webp",
  bottleDetail: "/img/bottle-detail.webp",
  cobrand: "/img/cobrand.webp",
  room: "/img/room.webp",
  hospital: "/img/hospital.webp",
  office: "/img/office.webp",
  lounge: "/img/lounge.webp",
  restaurant: "/img/restaurant.webp",
  banquet: "/img/banquet.webp",
  spa: "/img/spa.webp",
  greenery: "/img/greenery.webp",
  source: "/img/source.webp",
  treatment: "/img/treatment.webp",
  lab: "/img/lab.webp",
  bottling: "/img/bottling.webp",
  inspection: "/img/inspection.webp",
  cta: "/img/cta.webp",
};
